import * as Yup from 'yup';
import { MTA_ADDRESS_CHANGE_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';

interface IChangeOfAddress {
	businessUse: boolean;
}
const changeOfAddressSchema = (businessUse: IChangeOfAddress) => {
	Yup.object().shape({
		annualMileage: Yup.number()
			.min(0, MTA_ADDRESS_CHANGE_ERRORS.annualMileageGreaterThanZero)
			.required(MTA_ADDRESS_CHANGE_ERRORS.annualMileageRequired),
		businessMileage: Yup.mixed().when('vehicleUse', {
			is: () => businessUse,
			then: () =>
				Yup.number()
					.min(1, MTA_ADDRESS_CHANGE_ERRORS.businessMileageGreaterThanZero)
					.required(MTA_ADDRESS_CHANGE_ERRORS.businessMileageRequired),
			otherwise: (schema) => schema.notRequired(),
		}),
		keptOvernight: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.keptOvernight),
		overnightAddress: Yup.mixed().when('overnightAddressIsAway', {
			is: 'yes',
			then: () =>
				Yup.object().shape({
					line1: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.addressRequired),
				}),
			otherwise: (schema) => schema.notRequired(),
		}),
		overnightAddressIsAway: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.overnightAddressIsAwayRequired),
		isHomeOwner: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.homeOwnerRequired),
	});
};

export default changeOfAddressSchema;
